import React from 'react';
import { useConnection } from '@xyflow/react';

export default function ConnectionLine({ fromX, fromY, toX, toY }) {
    useConnection();  // keep connection context active

    return (
        <g>
            <path
                fill="none"
                stroke={'#4A90D9'}
                strokeWidth={2}
                className="animated"
                d={`M${fromX},${fromY} C ${fromX} ${toY} ${fromX} ${toY} ${toX},${toY}`}
            />
            <circle
                cx={toX}
                cy={toY}
                fill="#fff"
                r={5}
                stroke={'#4A90D9'}
                strokeWidth={2}
            />
            <circle
                cx={toX}
                cy={toY}
                fill="none"
                r={8}
                stroke={'#4A90D9'}
                strokeWidth={1}
                opacity={0.4}
            />
        </g>
    );
};